import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import Edit from '@material-ui/icons/Edit'
import TextField from "@material-ui/core/TextField";

export default class GapTimers extends Framework.Components.Collection {
	constructor(props) {

		let model = new API.BuildClass(Types.Roles._name, API.RequestType.READ_ALL);
		super(props,model);
		this.state.limit = 16;
		this.state.edit_modal = false;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns=[
			{
				Header: "Role",
				id: 'name',
				/** @param {Roles_Object} obj */
				accessor: obj => obj.name,
			},
			{
				Header: "Timer Value (minutes)",
				id: 'afk_timer',
				/** @param {Roles_Object} obj */
				accessor: obj => obj.afk_timer,
			},
			{
				Header: "Edit",
				id: "edit",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 50,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<Button color="green-meadow" size={"sm"} block={true} onClick={() => {
							this.state.timer_value = props.original.afk_timer ?? 0;
							this.state.timer_pkey = props.original.pkey;
							this.setState({edit_modal: true});
						}}>
							<Edit fontSize={'small'}/>
						</Button>
					);
				}
			},

		]
		const regexp = new RegExp(/\D/, 'g');
		return (
			<Card>
				<CardContent>
					
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data.filter((item) => !['Executive', 'Hidden', 'Developer', 'Field Engineer'].includes(item.name))}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
				<Modal
					isOpen={this.state.edit_modal}
					toggle={() => {
						this.setState({edit_modal: false})
					}}
					size={"sm"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Edit Timer
					</ModalHeader>
					<ModalBody>
						<div className="form-group">
							<TextField
								fullWidth={true}
								size={"small"}
								label={"Timer Value (minutes)"}
								value={this.state.timer_value}
								variant="outlined"
								onChange={(e) => {this.setState({timer_value: e.currentTarget.value.replaceAll(regexp, '')})}}
							/>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={async () => {
							let roleModel = new API.BuildClass(Types.Roles._name, API.RequestType.UPDATE);
							roleModel.object.afk_timer = this.state.timer_value ? this.state.timer_value : null;
							roleModel.object.pkey = this.state.timer_pkey;
							await roleModel.submit(null, 'POST')
							this.setState({edit_modal: false, timer_pkey: null, timer_value: 0, key: Math.random()})
						}}>Save</Button>

						<Button color="secondary" onClick={() => {
							this.setState({edit_modal: false, timer_value: 0, timer_pkey: null})
						}}>Close</Button>
					</ModalFooter>
				</Modal>
			</Card>
		)
	}
}
